<template>
  <b-button
    variant="outline-warning"
    size="sm"
    :disabled="loading"
    @click="resend"
  >
    <b-spinner v-if="loading" small class="mr-1" />
    {{ loading ? "Resending..." : "Resend" }}
  </b-button>
</template>

<script>
import donorService from "../../../assets/services/donor.service";

export default {
  name: "ResendNotificationButton",
  props: {
    notificationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async resend() {
      this.loading = true;
      try {
        const { data } = await donorService.resendMLCNotification({
          notification_id: this.notificationId,
        });
        if (data.status) {
          this.$alert.show("Notification resent successfully", "success");
          this.$emit("resent");
        } else {
          this.$alert.show(data.msg || "Failed to resend notification");
        }
      } catch (error) {
        this.$alert.show("Error resending notification");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
